import { FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ELanguage } from "../models/enums/language";
import IUser from "../models/user";
import UserService from "../services/user/UserService";
import Auth from "../services/auth/AuthService";
import { isValidPassword } from "../utils/passwordUtils";
import { routes } from "../routes";

const useRegister = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [code, setCode] = useState("");
    const [terms, setTerms] = useState(false);
    const [newsletter, setNewsletter] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        if (!isNameValid || !isValidPassword(password)) return;

        const newUser: IUser | null = await UserService.PostRegister(
            name,
            code,
            terms,
            newsletter,
            ELanguage.English,
            email,
            password
        );
        if (!newUser) return;

        const req = await UserService.PostLogin(email, password);
        if (!req) return;

        newUser.guid = req.data;
        if (newUser) Auth.setAuth(newUser);

        navigate(routes.home, { replace: true });
    };

    const isNameValid = () => {
        const nameRegex = new RegExp(
            "/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u"
        );
        return nameRegex.test(name);
    };

    return {
        name,
        setName,
        email,
        setEmail,
        password,
        setPassword,
        confirmPassword,
        setConfirmPassword,
        code,
        setCode,
        terms,
        setTerms,
        newsletter,
        setNewsletter,
        handleSubmit,
    };
};

export default useRegister;
